import {
  Component,
  HostListener,
  inject,
  OnInit,
  ChangeDetectionStrategy,
  effect,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from './reducers';
import { InitEmbeddedApp, ResizeEvent } from './core/store/core.actions';
import { embeddedAppSelector } from './core/store/core.selectors';
import { environment } from '../environments/environment';
import { UserFlowStore } from './core/store/user-flow.store';
import { IntercomStore } from './core/store/intercom.store';
import { SdEmbedMessagingService } from './core/services/sd-embed-messaging.service';
import { UpdateService } from './core/services/update.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <router-outlet /> `,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly store = inject<Store<AppState>>(Store);

  isLoggingOut = false;
  isIframe = false;
  environment = environment;
  private readonly userFlowStore = inject(UserFlowStore);
  private readonly intercomStore = inject(IntercomStore);
  private readonly embedMessaging = inject(SdEmbedMessagingService);
  private readonly updateService = inject(UpdateService);

  // SPD-4237: mirror the embedded-app state onto a body class so global
  // overlay styles (e.g. the signature-workflow-dialog panel) can size the
  // dialog to the full viewport when MY runs inside a parent iframe.
  private readonly embeddedApp = this.store.selectSignal(embeddedAppSelector);

  constructor() {
    this.store.dispatch(
      new ResizeEvent({ width: window.innerWidth, height: window.innerHeight })
    );
    this.store.dispatch(new InitEmbeddedApp());

    effect(() => {
      const embedded = this.embeddedApp();
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('sd-embedded-app', embedded);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.store.dispatch(
      new ResizeEvent({
        width: event.target.innerWidth,
        height: event.target.innerHeight,
      })
    );
  }
  ngOnInit(): void {
    this.userFlowStore.initUserFlow();
  }
}
